import React, { useContext } from 'react';
import styled from 'styled-components';
import { FlexMiddle, SmallSemiBold, Tooltip } from '@ubeya/shared-web/components';
import { ReactComponent as CalendarIcon } from '@ubeya/shared-web/assets/calendar.svg';
import { ReactComponent as NoShowIcon } from '@ubeya/shared-web/assets/no-show-red.svg';
import { ReactComponent as StarIcon } from '@ubeya/shared-web/assets/star-gold.svg';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useEmployeeKpiStats from '@ubeya/shared/hooks/employees/useEmployeeKpiStats';

const Wrapper = styled(FlexMiddle)`
  justify-content: center;
  gap: 16px;
`;

const Kpi = styled(FlexMiddle)`
  gap: 4px;

  svg {
    width: 16px;
    height: 16px;
  }
`;

const Value = styled(SmallSemiBold)`
  color: ${({ theme, $isDanger }) => ($isDanger ? theme.colors.redNegative : theme.colors.black)};
`;

const EmployeeKpis = ({ employeeId, firstName, rating = 0, jobsRatingCount = 0 }) => {
  const { t } = useContext(ConfigContext);

  const { shiftsWorked, noShows, noShowDenominator } = useEmployeeKpiStats(employeeId);

  const kpis = [
    rating > 0 && {
      key: 'rating',
      Icon: StarIcon,
      value: rating,
      tooltip: jobsRatingCount ? t('basedOnEvents', { totalEvents: jobsRatingCount }) : null
    },
    {
      key: 'shifts',
      Icon: CalendarIcon,
      value: shiftsWorked,
      tooltip: t('kpiShiftsWorkedTooltip', { firstName })
    },
    noShows > 0 && {
      key: 'noShows',
      Icon: NoShowIcon,
      value: noShows,
      isDanger: true,
      tooltip: t('employeeNoShowTooltip', {
        firstName,
        noShowsCount: noShows,
        shiftCount: noShowDenominator
      })
    }
  ].filter(Boolean);

  if (kpis.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      {kpis.map(({ key, Icon, value, isDanger, tooltip }) => (
        <Tooltip key={key} body={tooltip} disabled={!tooltip}>
          <Kpi>
            <Icon />
            <Value $isDanger={isDanger}>{value}</Value>
          </Kpi>
        </Tooltip>
      ))}
    </Wrapper>
  );
};

export default EmployeeKpis;
